import type { CSSProperties, ReactNode } from 'react';
import styles from './FlipCard.module.css';

/**
 * Deals a card: it starts face down and turns over after `delay` seconds. The face is in the
 * page from the first moment, so it is read at once whatever the animation is doing; with
 * "reduce motion" the card is simply there, face up.
 */
export function FlipCard({
  children,
  delay = 0,
  className,
}: {
  children: ReactNode;
  delay?: number;
  className?: string;
}) {
  return (
    <div className={[styles['flip'], className ?? ''].join(' ')}>
      <div className={styles['inner']} style={{ '--delay': `${delay}s` } as CSSProperties}>
        <div className={styles['front']}>{children}</div>
        <div className={styles['back']} aria-hidden="true">
          <svg className={styles['emblem']} viewBox="-10 -10 20 20" focusable="false">
            <polygon
              points="0,-9 2.6,-3 9,-3 3.8,1.2 5.8,8 0,4 -5.8,8 -3.8,1.2 -9,-3 -2.6,-3"
              fill="currentColor"
            />
          </svg>
        </div>
      </div>
    </div>
  );
}
